import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children: ReactNode): ReactNode => {
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading /></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
const TeacherIndex = lazy(() => import('../../pages/Mis/Teacher'))
const TeacherAdd = lazy(() => import('../../pages/Mis/Teacher/add'))
const TeacherEdit = lazy(() => import('../../pages/Mis/Teacher/edit'))

const CategoryIndex = lazy(() => import('../../pages/Mis/Category'))

const Article = lazy(() => import('../../pages/Mis/Article'))
const ArticleAdd = lazy(() => import('../../pages/Mis/Article/add'))
const ArticleEdit = lazy(() => import('../../pages/Mis/Article/edit'))
const Config = lazy(() => import('../../pages/Mis/Config'))

const MisRouter: RouteObjectRule[] = [
	{
		path: "/mis",
		children: [
			{
				path: "/mis/teacher",
				element: lazyLoad(<TeacherIndex />)
			},
			{
				path: "/mis/teacher/add",
				element: lazyLoad(<TeacherAdd />)
			},
			{
				path: "/mis/teacher/edit/:id",
				element: lazyLoad(<TeacherEdit />)
			},

			{
				path: "/mis/category",
				element: lazyLoad(<CategoryIndex />)
			},

			{
				element: lazyLoad(<Article />),
				path: '/mis/article',
			},
			{
				path: "/mis/article/add",
				element: lazyLoad(<ArticleAdd />)
			},
			{
				path: "/mis/article/edit/:id",
				element: lazyLoad(<ArticleEdit />)
			},
			{
				path: "/mis/config",
				element: lazyLoad(<Config />)
			},
		]
	}
];

export default MisRouter;